import React from 'react';
import { 
  Recycle,
  Building,
  Award,
  TrendingUp,
  Users,
  Leaf,
  Car,
  CheckCircle 
} from 'lucide-react';
import USAFlag from '../icons/USAFlag';

const StatsSection = () => {
  const stats = [
    {
      value: "40+",
      label: "Years Experience",
      description: "Industry Leadership",
      icon: Award,
      color: "text-automats-red"
    },
    {
      value: "200,000",
      label: "Sq Ft Facility", 
      description: "American Manufacturing",
      icon: Building,
      color: "text-automats-red"
    },
    {
      value: "100%",
      label: "Recycled Materials",
      description: "Environmental Commitment",
      icon: Recycle,
      color: "text-automats-eco-green"
    },
    {
      value: "Made in USA",
      label: "Quality Promise",
      description: "Local Excellence",
      icon: USAFlag,
      color: "text-automats-red"
    }
  ];

  return (
    <section className="py-20 lg:py-24 bg-transparent">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-semibold text-automats-black mb-6">
            The AutoMats Advantage in Numbers
          </h2>
          <p className="text-xl text-automats-black max-w-3xl mx-auto leading-relaxed">
            Premium American manufacturing excellence delivering quality results 
            for dealers nationwide.
          </p>
        </div>

        {/* Stats Cards - Hover Only */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-6xl mx-auto">
          {stats.map((stat, index) => {
            const IconComponent = stat.icon;
            return (
              <div 
                key={index} 
                className="group bg-white rounded-2xl p-8 text-center transition-all duration-500 hover:shadow-2xl hover:shadow-gray-200/50 hover:transform hover:-translate-y-2 shadow-lg shadow-gray-100"
              >
                <div className="w-16 h-16 rounded-2xl mx-auto mb-6 flex items-center justify-center transition-all duration-500 bg-gradient-to-br from-gray-50 to-gray-100 group-hover:from-automats-red group-hover:to-red-600 group-hover:shadow-lg group-hover:shadow-automats-red/30">
                  <IconComponent className={`h-8 w-8 transition-all duration-500 ${
                    stat.color === 'text-automats-eco-green' 
                      ? 'text-automats-eco-green group-hover:!text-white' 
                      : 'text-automats-red group-hover:!text-white'
                  }`} />
                </div>
                <div className="text-4xl font-semibold text-automats-red mb-3 transition-all duration-300 group-hover:scale-110">
                  {stat.value}
                </div>
                <div className="text-xl font-semibold text-automats-black mb-2">
                  {stat.label}
                </div>
                <div className="text-sm text-automats-black opacity-70">
                  {stat.description}
                </div>
              </div>
            );
          })}
        </div>

        {/* Premium CTA Section */}
        <div className="mt-20 text-center">
          <div className="max-w-4xl mx-auto">
            <h3 className="text-5xl font-semibold text-automats-black mb-8 leading-tight">
              Ready to Experience the Difference?
            </h3>
            <p className="text-lg sm:text-xl lg:text-2xl text-automats-black mb-12 leading-relaxed font-light px-4">
              Join dealers nationwide who've made the switch to AutoMats premium floor mats
            </p>
            <div className="flex justify-center">
              <a 
                href="mailto:sales@automats.us?subject=Sample Kit Request&body=Hello, I would like to request a sample kit to evaluate AutoMats floor mats for my business."
                className="btn-clean btn-premium text-white text-lg font-medium"
              >
                Request Sample Kit
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StatsSection;